import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ExamService from "../../services/exam.service";

export const getExam = createAsyncThunk(
  "exam/getExam",
  async (_, thunkAPI) => {
    try {
      const response = await ExamService.getExam();
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

const initialState = {
  loading: false,
  error: null,
  exam: [],
};

const examSlice = createSlice({
  name: "exam",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder

      // ================= Fee Category =================

      .addCase(getExam.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getExam.fulfilled, (state, action) => {
        state.loading = false;
        state.exam = action.payload?.data || [];
      })
      .addCase(getExam.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default examSlice.reducer;